const headers = {
  name: "Dashboard",
  components: [
    {
      type: "filter",
      name: "branch",
      allowClear: true,
      showSearch: true,
      filterOption: false,
      placeholder: "Select a branch",
      api: "get-all-branches",
      value: null,
      options: null,
      className: "w-80",
    },
    {
      type: "date",
      name: "date",
      value: new Date(),
      disabledDate: true,
    },
  ],
};

export default headers;
